<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>통합 검색</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">통합 검색</p>
            <search-bar :size="100" :text="search" v-on:onSearch="searchQna"></search-bar>
        </div>

        <div id="data" class="screen-width">
            <div class="row align-space-between" style="width: 100%">
                <div class="row" style="gap: 14px; margin-bottom: 16px">
                    <p style="font-size: 28px; font-weight: bold">많이하는 질문</p>
                </div>
            </div>
            <div id="data-list">
                <post-list-item 
                    v-for="solution in solutionList" 
                    :key="solution" 
                    :title="solution.title" 
                    :category="'조회수 ' + solution.viewCount" 
                    :date="solution.createdAt" 
                    :id="String(solution.id)">
                </post-list-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentSolutionPage"
                :totalPages="totalSolutionPages"
                v-on:update="loadSolutionPageData"
            ></custom-pagination>
        </div>

         <div id="data" class="screen-width">
            <div class="row align-space-between" style="width: 100%">
                <div class="row" style="gap: 14px; margin-bottom: 16px">
                    <p style="font-size: 28px; font-weight: bold">다운로드</p>
                </div>
            </div>
            <div id="data-list">
                <download-item
                    v-for="download in downloadList"
                    :key="download"
                    :title="download.title"
                    :filename="download.file_name"
                    :category="'분류'"
                    :date="'2025-01-14'"
                ></download-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentDownloadPage"
                :totalPages="totalDownloadPages"
                v-on:update="loadPageDownloadData"
            ></custom-pagination>
        </div>

        <div id="data" class="screen-width">
            <div class="row align-space-between" style="width: 100%">
                <div class="row" style="gap: 14px; margin-bottom: 16px">
                    <p style="font-size: 28px; font-weight: bold">질문과 답변</p>
                </div>
            </div>
            <div id="data-list">
                <question-list-item
                    v-for="qna in qnaList"
                    :key="qna"
                    :title="qna.title"
                    :category="'분류'"
                    :date="qna.createdAt"
                    :id="qna.id"
                ></question-list-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentQnaPage"
                :totalPages="totalQnaPages"
                v-on:update="loadQnaPageData"
            ></custom-pagination>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import QuestionListItem from "@/components/QuestionListItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import PostListItem from "@/components/PostListItem.vue";
import DownloadItem from "@/components/DownloadItem.vue";

export default {
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        CustomPagination,
        QuestionListItem,
        PostListItem,
        DownloadItem
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const route = useRoute(); // 현재 라우트 객체를 반응형 참조로 가져옵니다.

        const searchKeyword = computed(() => {
            return route.query.search;
        }); // route.query.name에 접근하는 computed 속성을 생성합니다.


        const search = ref(route.query.search);
        
        const solutionList = computed(() => {
            return store.getters.getSolutionList;
        });

        const downloadList = computed(() => {
            return store.getters.getDownloadList;
        });

        const qnaList = computed(() => {
            return store.getters.getQnaList;
        });

        const currentQnaPage = ref(1);
        const totalQnaPages = computed(() => {
            return Math.ceil(store.getters.getQnaTotalCount / 10)
        });
        const loadQnaPageData = (page) => {
            currentQnaPage.value = page;
            getQnaList();
        };

        const getQnaList = () => {
            store.dispatch("getQnaList", {
                take: 10,
                search: search.value,
                page: currentQnaPage.value,
            });
        }

        const searchQna = (word) => {
            search.value = word
            getQnaList();
            getSolutionList();
            getDownloadList();
        };

        const createQna = () => {
            router.push({ path: "/add/qna" });
        };

        const moveQnaPage = (id) => {
            router.push({ path: `/customer/qna/${id}` });
        };


        const currentSolutionPage = ref(1);
        const totalSolutionPages = computed(() => {
            return Math.ceil(store.getters.getSolutionTotalCount / 10)
        });
        const loadSolutionPageData = (page) => {
            currentSolutionPage.value = page;
            getSolutionList();
        };

        const currentDownloadPage = ref(1);
        const totalDownloadPages = computed(() => {
            return Math.ceil(store.getters.getDownloadTotalCount / 10)
        });
        const loadDownloadPageData = (page) => {
            currentDownloadPage.value = page;
            getDownloadList();
        };


        const getSolutionList = () => {
            store.dispatch("getSolutionList", {
                search: search.value,
                take: 5,
                page: currentSolutionPage.value,
                order: "createdAt"
            })
        }

        const getDownloadList = () => {
            store.dispatch("getDownloadList", {
                search:search.value,
                take: 5,
                page: currentDownloadPage.value
            })
        }

        onMounted( () => {
            search.value = route.query.search;
            getSolutionList();
            getDownloadList();
            getQnaList();
        });

        return {
            solutionList,
            currentQnaPage,
            totalQnaPages,
            loadQnaPageData,
            downloadList,
            qnaList,
            search,
            searchQna,
            moveQnaPage,
            createQna,
            searchKeyword,
            loadSolutionPageData,
            totalSolutionPages,
            currentSolutionPage,
            loadDownloadPageData,
            totalDownloadPages,
            currentDownloadPage,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
    flex-wrap: wrap;
}

#product-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap;
}


#data {
    padding: 32px 0px;
}

#data-list {
    width: 100%;
    border-top: 1px solid black;
}

#search {
    padding: 32px 0px;
    gap: 24px;
}
</style>
